import { ref } from 'vue';

let progressBarInstance: any = null;

export function usePageProgress() {
  const setProgressBarInstance = (instance: any) => {
    progressBarInstance = instance;
  };

  const start = () => {
    if (progressBarInstance) {
      progressBarInstance.start();
    }
  };

  const complete = () => {
    if (progressBarInstance) {
      progressBarInstance.complete();
    }
  };

  const error = () => {
    if (progressBarInstance) {
      progressBarInstance.error();
    }
  };

  return {
    setProgressBarInstance,
    start,
    complete,
    error
  };
}